import { useMutation } from "@tanstack/react-query";

import {
  type HealthCategory,
  type PortfolioHealthReasonings,
  type PortfolioHealthScores,
} from "@/hooks/queries/portfolio/useGetPortfolioMatrix";
import { guacHttpClient } from "@/lib/http";
import { type HttpResponse } from "@/types";

export interface SendPortfolioHealthFeedbackRequest {
  companyId: string;
  companyName: string;
  feedback: string;
  health: PortfolioHealthScores | null;
  jobId: string;
  jobTitle: string;
  reasons: PortfolioHealthReasonings | null;
  score: number;
  scoreBreakdown: Partial<Record<HealthCategory, number>>;
}

export function useSendPortfolioHealthFeedback() {
  return useMutation({
    mutationFn: async (request: SendPortfolioHealthFeedbackRequest) => {
      const res = await guacHttpClient.post<
        { ok: boolean },
        HttpResponse<{ ok: boolean }>,
        SendPortfolioHealthFeedbackRequest
      >("portfolio/health-feedback", request);

      return res.data;
    },
  });
}
